import green from './assets/greenhome.jpg'
import snow from './assets/snowhome.jpg'
import desert from './assets/deserthome.jpg'

const images = [green, snow, desert, undefined]

const getStartingBid = () => {
  const startingBid =
    Math.round((Math.floor(Math.random() * 1000000) + 250000) / 1000) * 1000
  return startingBid.toString()
}

const TPSProperty = i => ({
  global_property_id: i,
  is_asset_online_event: false,
  product_type: 'foreclosure/trustee',
  sale_time: '08:00 am',
  property_address: `${i} E Pershing Ave`,
  property_city: 'Scottsdale',
  property_is_hot: Math.random() > 0.5,
  auction_start_date: '2018-05-07',
  auction_end_date: '2018-06-09',
  starting_bid: getStartingBid(),
  suppress_opening_bid: Math.random() > 0.5,
  price_estimate:
    Math.round((Math.floor(Math.random() * 2000000) + 20000) / 1000) * 1000,
  show_reserve: Math.random() > 0.5,
  valuation_estimate:
    Math.round((Math.floor(Math.random() * 2000000) + 100000) / 1000) * 1000,
  valuation_available: Math.random() > 0.5,
  thumbnail: images[i % images.length],
  beds: (i || 1) * (Math.floor(Math.random() * 10) + 1),
  baths: (i || 1) * (Math.floor(Math.random() * 10) + 1),
  sqft: (i || 1) * 250,
  pdp_url:
    'https://dos.qa.auction.com/details/45-las-castanetas-henry-oh-90804-2600090-e_roger01',
  venue_time: '9:00 Am',
  is_broker_commission_available: Math.random() > 0.5,
  financing_available: Math.random() > 0.5,
  buyer_premium_avail: Math.random() > 0.5,
  interior_access: Math.random() > 0.5,
  occupancy_status: Math.random() > 0.5 ? 'Vacant' : '-',
  activation_date: '2021-02-16T14:20:43',
  estimated_rent_high:
    Math.random() > 0.5 ? Math.floor(Math.random() * 10000) + 1000 : '',
  estimated_rent_mid:
    Math.random() > 0.5 ? Math.floor(Math.random() * 10000) + 500 : '',
})

const REOProperty = i => ({
  global_property_id: i,
  is_asset_online_event: true,
  property_address: `${i} E Pershing Ave`,
  property_city: 'Scottsdale',
  property_is_hot: Math.random() > 0.5,
  auction_start_date: '2018-05-07',
  auction_end_date: '2018-06-09',
  starting_bid: getStartingBid(),
  product_type: Math.random() > 0.5 ? 'Bank Owned' : 'Short Sale',
  suppress_opening_bid: Math.random() > 0.5,
  price_estimate:
    Math.round((Math.floor(Math.random() * 2000000) + 20000) / 1000) * 1000,
  show_reserve: Math.random() > 0.5,
  valuation_estimate:
    Math.round((Math.floor(Math.random() * 2000000) + 100000) / 1000) * 1000,
  valuation_available: Math.random() > 0.5,
  thumbnail: images[i % images.length],
  beds: (i || 1) * (Math.floor(Math.random() * 10) + 1),
  baths: (i || 1) * (Math.floor(Math.random() * 10) + 1),
  sqft: (i || 1) * 250,
  pdp_url:
    'https://dos.qa.auction.com/details/45-las-castanetas-henry-oh-90804-2600090-e_roger01',
  venue_time: '5:00 Pm',
  is_broker_commission_available: Math.random() > 0.5,
  financing_available: Math.random() > 0.5,
  buyer_premium_avail: Math.random() > 0.5,
  interior_access: Math.random() > 0.5,
  occupancy_status: Math.random() > 0.5 ? 'Vacant' : '-',
  activation_date: '2021-02-16T14:20:43',
  estimated_rent_high:
    Math.random() > 0.5 ? Math.floor(Math.random() * 10000) + 1000 : '',
  estimated_rent_mid:
    Math.random() > 0.5 ? Math.floor(Math.random() * 10000) + 500 : '',
})

export const getTestProperty = i =>
  i % 2 === 0 ? REOProperty(i) : TPSProperty(i)
